import { toInteger } from 'lodash';
import { NumberParam, withDefault } from 'use-query-params';

export const defaultPageSize = 15;
export const defaultPage = 1;

export const pageSizes = [
  { label: defaultPageSize.toString(), value: defaultPageSize },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
  { label: '50', value: 50 },
  { label: '100', value: 100 }
];

export const defaultPaginationFilters = {
  pageSize: withDefault(NumberParam, defaultPageSize),
  page: withDefault(NumberParam, defaultPage)
};

export function generatePaginationFilters(
  pageSize: number | undefined,
  page: number | undefined
): EntityFilters {
  return {
    pagination: true,
    itemsPerPage: toInteger(pageSize),
    page: toInteger(page)
  };
}
